import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import bulkRequestKeys from '@app/features/bulkRequest/queryKey';
import coalesceGlobalErrorMessage from '@app/libs/coalesceGlobalErrorMessage';
import { modalOpen } from '@app/store/modal/actions';
import { deleteBulkRequest } from '@app/store/transport-layer/bulk-request/bulk-requests';

const useDeleteBulkRequest = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError, Parameters<typeof deleteBulkRequest>>(
    bulkRequestKeys.mutation.delete(),
    (vs) => deleteBulkRequest(...vs),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(bulkRequestKeys.query.lists());
      },
      onError: (error) => {
        dispatch(
          modalOpen('CONFIRM', {
            title: '대량전송 삭제 실패',
            content: coalesceGlobalErrorMessage(error.message),
          })
        );
      },
    }
  );
};

export default useDeleteBulkRequest;
